import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";
import Sidebar from "components/common/sidebar/Sidebar";
import SidePanel from "../sidePanel/SidePanel";
import Header from "components/common/header/Header";
import { useAuth } from "hooks/authentication/useAuth";
import { usePermission } from "hooks/permission/usePermission";
import { useNavigate } from "react-router-dom";
import { fetchProfile } from "services/FetchProfile";
import { useProfilePicture } from "hooks/UserProfilePicture/UserProfilePicture";

const Layout = ({ children }) => {
  const auth = useAuth();

  const { setUserProfilePicture, setIsFetchingState } = useProfilePicture();

  const { setPermissions } = usePermission();
  const [showNav, setShowNav] = useState(true);
  const [showPanel, setShowPanel] = useState(false);
  const togglePanel = () => {
    setShowPanel((pre) => !pre);
  };
  const hidePanel = () => {
    setShowPanel(false);
  };
  const toggleNav = () => {
    setShowNav((pre) => !pre);
  };
  const hideNav = () => {
    setShowNav(false);
  };
  const fetchUserProfile = async () => {
    await fetchProfile(
      auth,
      setPermissions,
      setUserProfilePicture,
      setIsFetchingState
    );
  };
  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <div>
      <Header
        toggleNav={toggleNav}
        togglePanel={togglePanel}
        showNav={showNav}
      />
      <div className="layout-div">
        <>
          {window.location.pathname !== "/unauthorized-user" && (
            <Sidebar show={showNav} hideNav={hideNav} />
          )}
          <SidePanel show={showPanel} hidePanel={hidePanel} />
        </>

        {children}
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Layout;
